import { render, staticRenderFns } from "./footer-aside.vue?vue&type=template&id=1d8d4a47"
import script from "./footer-aside.vue?vue&type=script&lang=js"
export * from "./footer-aside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports